import { forwardRef } from "react";
import { Container } from "./styled";

export const CheckBox = forwardRef(
  ({ name, placeholder, value, onChange }, ref) => {
    return (
      <Container
        onClick={() => {
          onChange(!value);
        }}
      >
        <input readOnly ref={ref} checked={value} type="checkbox" />
        <label htmlFor={name}>{placeholder}</label>
      </Container>
    );
  }
);
